// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Promise from "@ryyppy/rescript-promise/src/Promise.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

function toOk(x) {
  if (x !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: Caml_option.valFromOption(x)
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: undefined
          };
  }
}

function okNotEmpty(x) {
  if (x.TAG === /* Ok */0) {
    return toOk(x._0);
  } else {
    return {
            TAG: /* Error */1,
            _0: undefined
          };
  }
}

function parseJsonIfOk(resp) {
  if (resp.ok) {
    return $$Promise.$$catch(resp.json().then(function (json) {
                    return Promise.resolve({
                                TAG: /* Ok */0,
                                _0: json
                              });
                  }), (function (_error) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: resp
                            });
                }));
  } else {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: resp
              });
  }
}

export {
  toOk ,
  okNotEmpty ,
  parseJsonIfOk ,
  
}
/* No side effect */
